<template>

  <div class="parent">
    <span class="back" v-tap="{methods:goback}">

    </span>

    <span class="title" v-text="title">

    </span>

  </div>

</template>

<script type="text/ecmascript-6">
  export default{
    props: {
      title: {
        type: String
      }
    },
    methods: {
      goback () {
        this.$router.goBack();
      }
    }
  };

</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../assets/scss/base.scss';

  .parent {
    width: px2rem(750);
    height: px2rem(96);
    font-size: 0;
    padding-top: px2rem(48);
    @include bg-img('../assets/img/common/rectangle');

    .back {
      cursor: pointer;
      width: px2rem(65);
      height: px2rem(96);
      display: inline-block;
      margin-left: px2rem(20);
      vertical-align: top;
      background: url("../assets/img/common/return@2x.png") no-repeat px2rem(20) px2rem(30);
      background-size: px2rem(23) px2rem(41);
    }
    .title {
      display: inline-block;
      width: px2rem(550);
      height: px2rem(96);
      line-height: px2rem(96);
      font-size: px2rem(40);
      text-align: center;
      color: white;
    }
  }


</style>



// WEBPACK FOOTER //
// VNavigator.vue?561cd996